import * as actions from '../Actions/Blocks';

export const blocksReducer = (state = {}, action) => {
      switch (action.type) {
          case actions.GET_BLOCKS_REQUESTED:
              return { ...state, isLoading: true };
          case actions.GET_BLOCKS_DONE:
              return { ...state, isLoading: false, blocks: action.payload };
          case actions.GET_BLOCKS_FAILED:
              return {...state, isLoading: false, isError: true, error: action.payload};
          default:
              return state;
      }
 };


 export const pickedBlocksReducer = (state = {}, action) => {
       switch (action.type) {
           case actions.GET_PICKED_BLOCKS:
               return { ...state, isLoading: false, pickedBlocks: action.payload };
           default:
               return state;
       }
  };

  export const activeBlocksReducer = (state = {}, action) => {
         switch (action.type) {
             case actions.GET_BLOCKS_DONE:
                 return { ...state, isLoading: false, activeBlocks: action.payload };
             default:
                 return state;
         }
    };

export const createListBlocksReducer = (state = {}, action) => {
    switch (action.type) {
        case actions.GET_CL_BLOCKS_REQUESTED:
            return { ...state, isLoading: true };
        case actions.GET_CL_BLOCKS_DONE:
            return { ...state, isLoading: false, blocks: action.payload };
        case actions.GET_CL_BLOCKS_FAILED:
            return {...state, isLoading: false, isError: true, error: action.payload};
        default:
            return state;
    }
};